import { render, staticRenderFns } from "./vpn.vue?vue&type=template&id=22c53e8b&scoped=true&"
import script from "./vpn.vue?vue&type=script&lang=js&"
export * from "./vpn.vue?vue&type=script&lang=js&"
import style0 from "./vpn.vue?vue&type=style&index=0&id=22c53e8b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c53e8b",
  null
  
)

export default component.exports